module.exports = "<ea-periodic-download-page></ea-periodic-download-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaPeriodicDownload/eaPeriodicDownloadPage/eaPeriodicDownloadPageModule.html
// module id = 1056
// module chunks = 12